import React from "react";
import InternalHeader from "~/components/Layout/components/InternalHeader";
import { useLang } from "~/hooks/useLang";
import ListAllAuditDispatchGroupReport from "./components/ListAllAuditDispatchGroupReport";

export default function AuditDispatchGroupReportTable() {
    const { translate } = useLang();
    
    return (
        <>
            <InternalHeader title={`${translate('Audit')}: ${translate('Dispatch group')}`} />
            <ListAllAuditDispatchGroupReport />
        </>
    )
}